import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Components
import AjaxController from '../system/ajaxController';
import { optionsSeason } from '../contract/systemdata';
import { options3LC } from '../contract/systemdata';
import { setActivePage, setUser, setToken } from '../../appSlice';

// Redux slices
import { enableFilter, disableFilter, setFilterValue, setSearching, setResult } from './searchSlice';

// SemanticUI components
import { Form, FormGroup, FormInput, FormSelect, Segment, Label, FormRadio, Icon, FormField, Button } from 'semantic-ui-react';

// Styles
import './search.css';


/**
 * 
 * @returns 
 */
const Max2SearchFilter = () => {
  // local state
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // global State
  const dispatch = useDispatch();
  const backendUrl = useSelector((state) => state.app.backend.baseProtocol) + '://' + useSelector((state) => state.app.backend.url);
  const searchFilter = useSelector((state) => state.search.filter);
  const pagination = useSelector((state) => state.search.pagination);
  const sorting = useSelector((state) => state.search.sorting);
  const user = useSelector((state) => state.app.user);



  /**
   * Handles changes in filter form fields
   * 
   * @param {string} filter
   * @param {string} action
   * @param {mixed} value  
   */
  const handleFilter = (filter, action, value) => {
    switch (action) {
      case 'ENABLE':  dispatch(enableFilter(filter)); break;
      case 'DISABLE': dispatch(disableFilter(filter)); break;
      case 'SET':     dispatch(setFilterValue({filter: filter, value: value})); break;
      default: break;
    }
  }


  
  /**
   * Sends the filter request 
   * http://localhost:8080/filter/W29iamVjdCBPYmplY3Rd
   * 
   * @param {string} backendUrl 
   * @param {object} filter 
   * @param {object} pagination 
   * @param {object} sorting 
   */
  const handleFilterClick = (backendUrl, filter, pagination, sorting) => {
    
    // encode filter params object
    const query = {
      filter: filter, 
      pagination: pagination,
      sorting: sorting
    }
    
    // Controller for AJAX requests
    const api = new AjaxController(backendUrl, () => {
      dispatch(setActivePage('START'));
      dispatch(setUser(null));
      dispatch(setToken(null));
    });
    
    
    // search for hotels
    const fetchData = async () => {
      try {

        // show loading animation
        dispatch(setSearching(true));

        // reduce objectCodes to names
        let reducedObjectCodes = [];
        if (typeof user.objectCodes !== 'undefined' && user.objectCodes.length) {
          user.objectCodes.forEach(objectCode => {
            reducedObjectCodes.push(objectCode.name);
          });
        }

        // send count request
        //const count = await api.get('/count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
        const count = await api.post('/count/' + btoa(JSON.stringify(query)).replaceAll('=', '_'), {code: reducedObjectCodes});

        // send filter request
        //const response = await api.get('/filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));
        const response = await api.post('/filter/' + btoa(JSON.stringify(query)).replaceAll('=', '_'), {code: reducedObjectCodes});
        
        // hide loading animation
        dispatch(setSearching(false));

        // display results
        dispatch(setResult({result: response, numberOfRecordsTotal: count}))

      } catch (err) {
        //setError(err.message);
        console.error(err.message)
      }
    };

    fetchData();
  }



  /**
   * Get filtered hotelcodes from server
   * 
   * @param {String} query 
   * @param {String} url 
   */
  const fetchOptions = async (query, url) => {
    setIsLoading(true);
    
    try {
      const api = new AjaxController(url, () => {
        dispatch(setActivePage('START'));
        dispatch(setUser(null));
        dispatch(setToken(null));
      });
      const hotelcodes = await api.get('/hotelcodes/' + btoa(JSON.stringify(query)).replaceAll('=', '_'));

      // filter hotelcodes
      if (typeof user.objectCodes !== 'undefined' && user.objectCodes.length) {
        let optionsHotelcode = [];
        hotelcodes.forEach(hotelcode => {
          user.objectCodes.forEach(objectCode => {
            if (hotelcode.value === objectCode.name) {
              optionsHotelcode.push(hotelcode);
            }
          });
        });
        setOptions(optionsHotelcode);
      } else {
        setOptions(hotelcodes);
      }
    } catch (error) {
      console.error("Fehler beim Laden der Optionen:", error);
    }
    setIsLoading(false);
  };



  /**
   * Handle input change in Dropdown
   * 
   * @param {Event} e 
   * @param {String} searchQuery 
   */
  const handleSearchChange = (e, { searchQuery }) => {
    setSearchQuery(searchQuery);

    // Load options after 3 or more characters
    if (searchQuery.length >= 3) {
      fetchOptions(searchQuery, backendUrl);
    } else {
      setOptions([]);
    }
  };


  return (
    <Segment textAlign='left' style={{margin: '25px'}}>
      <Label circular style={{marginBottom: '20px'}}><span style={{fontSize: '1.4em', margin: '10px'}}>Filter</span></Label>
      <Form>
        <FormGroup>
          <FormSelect
            fluid
            search
            selection
            clearable
            placeholder = "Bitte wählen"
            style = {{width: '200px'}} 
            label = 'Hotelcode'
            options = {options}
            loading = {isLoading}
            onSearchChange = {handleSearchChange}
            noResultsMessage = {
              searchQuery.length < 3
                ? "Bitte geben Sie mindestens 3 Zeichen ein"
                : "Keine Ergebnisse gefunden"
            }
            value = {searchFilter.code.value}
            onChange = {(event, formElement)=>handleFilter('code', 'SET', formElement.value)} 
          />
          <FormInput 
            fluid 
            label = 'Hotelname' 
            placeholder = 'Hotelname' 
            style = {{width: '500px'}} 
            value = {searchFilter.name.value}
            onChange = {(event, formElement)=>handleFilter('name', 'SET', formElement.value)} 
          />
          <FormSelect
            fluid
            search
            multiple
            label = 'Vertrag in Saison'
            options = {optionsSeason}
            placeholder = 'Saison'
            style = {{minWidth: '200px'}}
            value = {searchFilter.seasons.value}
            onChange = {(event, formElement)=>handleFilter('seasons', 'SET', formElement.value)} 
          />
        </FormGroup>
        <FormGroup>
          <FormSelect
            fluid
            search
            multiple
            style = {{width: '200px'}} 
            label = 'Zielgebiet'
            options = {options3LC}
            placeholder = 'Zielgebiet'
            value = {searchFilter.destinations.value}
            onChange = {(event, formElement)=>handleFilter('destinations', 'SET', formElement.value)} 
          />
          <FormInput 
            fluid 
            label = 'Hotelort' 
            placeholder = 'Hotelort' 
            style = {{width: '500px'}} 
            value = {searchFilter.city.value}
            onChange = {(event, formElement)=>handleFilter('city', 'SET', formElement.value)} 
          />
          <FormInput
            fluid
            type = "number"
            label = 'GIATA'
            placeholder = 'Giata'
            style = {{minWidth: '200px'}}
            value = {searchFilter.giata.value}
            onChange = {(event, formElement)=>handleFilter('giata', 'SET', formElement.value)} 
          />
        </FormGroup>
        <FormGroup>
          <FormRadio toggle label='aktiv?' checked={searchFilter.active.enabled} onClick={()=>handleFilter('active', searchFilter.active.enabled ? 'DISABLE' : 'ENABLE')} />
          {searchFilter.active.enabled ? (<FormRadio label='ja'   checked={searchFilter.active.value ===  true ? true : false} name='radioGroup_active' onClick={()=>handleFilter('active', 'SET',  true)} />) : (<FormRadio disabled label='ja' name='radioGroup_active' />)}
          {searchFilter.active.enabled ? (<FormRadio label='nein' checked={searchFilter.active.value === false ? true : false} name='radioGroup_active' onClick={()=>handleFilter('active', 'SET', false)} />) : (<FormRadio disabled label='nein' name='radioGroup_active' />)}

          <FormRadio toggle label='HLX' checked={searchFilter.hlx.enabled} onChange={()=>handleFilter('hlx', searchFilter.hlx.enabled ? 'DISABLE' : 'ENABLE')} />
          {searchFilter.hlx.enabled ? (<FormRadio label='ja'   checked={searchFilter.hlx.value ===  true ? true : false} name='radioGroup_hlx' onClick={()=>handleFilter('hlx', 'SET',  true)} />) : (<FormRadio disabled label='ja' name='radioGroup_hlx' />)}
          {searchFilter.hlx.enabled ? (<FormRadio label='nein' checked={searchFilter.hlx.value === false ? true : false} name='radioGroup_hlx' onClick={()=>handleFilter('hlx', 'SET', false)} />) : (<FormRadio disabled label='nein' name='radioGroup_hlx' />)}

          <FormRadio toggle label='TZO' checked={searchFilter.tzo.enabled} onChange={()=>handleFilter('tzo', searchFilter.tzo.enabled ? 'DISABLE' : 'ENABLE')} />
          {searchFilter.tzo.enabled ? (<FormRadio label='ja'   checked={searchFilter.tzo.value ===  true ? true : false} name='radioGroup_tzo' onClick={()=>handleFilter('tzo', 'SET',  true)} />) : (<FormRadio disabled label='ja' name='radioGroup_tzo' />)}
          {searchFilter.tzo.enabled ? (<FormRadio label='nein' checked={searchFilter.tzo.value === false ? true : false} name='radioGroup_tzo' onClick={()=>handleFilter('tzo', 'SET', false)} />) : (<FormRadio disabled label='nein' name='radioGroup_tzo' />)}
        </FormGroup>
        <FormField style={{height: '35px'}}>
          <Button primary circular icon labelPosition='left' onClick={()=>handleFilterClick(backendUrl, searchFilter, pagination, sorting)}><Icon name="filter" /> Filtern</Button>
        </FormField>
      </Form>
    </Segment>
  );
}

export default Max2SearchFilter;